// overlayKit/LowerThird.tsx — name + role/place, bottom-left.
// Migrated from ChocolateFullPreview inline LowerThird. Position scales with
// composition width via useVideoConfig (kept fixed-pixel for now — same as
// chocolate; future productions can extend with a region prop).
import React from "react";
import { useCurrentFrame, useVideoConfig, interpolate } from "remotion";
import { appear, FONT, TS, win } from "./utils";
import { useColor } from "./palette";

export type LowerThirdProps = {
  name: string;
  sub: string;
  italic?: string;
  nameS: number;
  subS: number;
  outS: number;
  /** Palette tokens (defaults: WHITE name, GOLD accent+sub, DIM italic). */
  accentColor?: string;
  nameColor?: string;
  subColor?: string;
  italicColor?: string;
};

export const LowerThird: React.FC<LowerThirdProps> = ({
  name, sub, italic, nameS, subS, outS,
  accentColor = "secondary", nameColor = "neutral", subColor = "secondary", italicColor = "cream",
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const t = frame / fps;
  const op = win(t, nameS - 0.2, outS);
  if (op <= 0.001) return null;
  const slideX = interpolate(t, [nameS - 0.25, nameS + 0.15], [-300, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp", easing: (v) => 1 - Math.pow(1 - v, 3),
  });
  const nameOp = appear(t, nameS, 0.16);
  const subOp = appear(t, subS, 0.2);
  const accentW = interpolate(t, [nameS - 0.2, nameS + 0.35], [0, 168], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const accentHex = useColor(accentColor);
  const nameHex = useColor(nameColor);
  const subHex = useColor(subColor);
  const italicHex = useColor(italicColor);
  return (
    <div style={{ position: "absolute", inset: 0, opacity: op }}>
      <div style={{ position: "absolute", bottom: 18, left: 22, transform: `translateX(${slideX}px)`, fontFamily: FONT }}>
        <div style={{ height: 2, width: accentW, background: accentHex, marginBottom: 9, boxShadow: `0 0 8px ${accentHex}88` }} />
        <div style={{ color: nameHex, fontSize: 34, fontWeight: 800, letterSpacing: "-0.5px", textShadow: TS, lineHeight: 1.05, opacity: nameOp }}>{name}</div>
        <div style={{ color: subHex, fontSize: 16, fontWeight: 600, letterSpacing: "0.18em", marginTop: 6, textShadow: TS, opacity: subOp }}>{sub}</div>
        {italic && <div style={{ color: italicHex, fontSize: 13, fontStyle: "italic", marginTop: 4, textShadow: TS, opacity: subOp }}>{italic}</div>}
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
